<div class="toolbar-wrapper">
  <div class="glxy-page-title-container">
    <!-- Optionally show nav toggle in toolbar -->
    @if (showNavToggle()) {
      <button
        mat-icon-button
        (click)="this.toggleNav()"
        class="glxy-page-nav-toggle"
        matTooltip=" {{ navToggleTooltip() | translate }}"
      >
        <mat-icon>menu</mat-icon>
      </button>
    }

    <!-- Back Button/Crumbing -->
    <ng-content select="glxy-page-nav" />

    <!-- Page Title and Title actions -->
    <ng-content select="glxy-page-title" />
  </div>

  <div class="glxy-page-action-container">
    <!-- Actions that are beside the page title -->
    <div class="glxy-page-title-actions-container">
      <ng-content select="glxy-page-title-actions" />
    </div>

    <!-- Main actions. On the far right -->
    <div class="glxy-page-main-actions-container">
      <ng-content select="glxy-page-actions" />
    </div>

    <div class="glxy-page-extra-content">
      <!-- Any other content added to <glxy-page-toolbar> goes here. -->
      <ng-content />
    </div>
  </div>
</div>

@if (showExtendedToolbar()) {
  <div class="galaxy-page-extended-toolbar-container">
    <ng-content select="glxy-page-extended-toolbar" />
  </div>
}
